const feedbackTheme = {
  color: {
    primary: "#00187E",
    primaryDark: "#001563",
    primaryDeep: "#00297A",
    accent: "#00BECC",
    text: "#202124",
    textMuted: "#5F6368",
    surface: "#FFFFFF",
    surfaceAlt: "#E6EAF5",
    border: "#D5D9E5",
    error: "#D62828",
    errorBg: "#FDECEC",
    warning: "#F5A524",
    warningBg: "#FEF5E1",
    success: "#16A34A",
    successBg: "#E8F5EE",
    info: "#00BECC",
    infoBg: "#E5F8FA",
  },
  font: {
    family: "'Poppins', system-ui, -apple-system, sans-serif",
    sizeSm: "12px",
    sizeMd: "14px",
    sizeLg: "16px",
    sizeXl: "20px",
    weightRegular: 400,
    weightMedium: 500,
    weightSemibold: 600,
    weightBold: 700,
  },
  radius: {
    sm: "6px",
    md: "8px",
    lg: "12px",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },
  toast: {
    position: "bottom-right",
    autoClose: {
      success: 5000,
      info: 5000,
      warning: 8000,
      error: false,
    },
  },
};

export default feedbackTheme;
